import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

//-----------------------------------------------
// Page Navigation
//-----------------------------------------------

function pageNavigation() {
  const blocks = [...document.querySelectorAll(".page-navigation")];
  if (!blocks.length) return;

  const header = document.querySelector(".header");

  const getOuterHeight = (el) => {
    if (!el) return 0;

    const style = getComputedStyle(el);

    return (
      el.getBoundingClientRect().height +
      parseFloat(style.marginTop || 0) +
      parseFloat(style.marginBottom || 0)
    );
  };

  const getOffsetY = (block) => {
    return getOuterHeight(header) + getOuterHeight(block);
  };

  blocks.forEach((block) => {
    const links = [
      ...block.querySelectorAll(".page-navigation__list-item-link"),
    ];
    if (!links.length) return;

    let offsetY = getOffsetY(block);

    const recalculateOffset = () => {
      offsetY = getOffsetY(block);
    };

    window.addEventListener("resize", recalculateOffset, { passive: true });

    links.forEach((link) => {
        const url = new URL(link.href, window.location.href);
        const targetId = url.hash.slice(1);

        if (!targetId) return;

        const target = document.getElementById(targetId);
        if (!target) return;

		// Scroll Trigger for making each section active on manual scroll
		ScrollTrigger.create({
			trigger: target,
			start: "top 60%",
			end: "bottom 60%",
			markers: false,
			onEnter: (self) => {
				// console.log('enter', self.isActive);
				links.forEach((item) => item.classList.remove("active"));
				if (self.isActive) {
					link.classList.add("active");
				}
			},
			onEnterBack: (self) => {
				// console.log('enter back', self.isActive);
				links.forEach((item) => item.classList.remove("active"));
				if (self.isActive) {
					link.classList.add("active");
				}
			},
			onLeave: (self) => {
				// console.log('leave', self.isActive);
			},
			onLeaveBack: (self) => {
				// console.log('leave back', self.isActive);
				links.forEach((item) => item.classList.remove("active"));
				if (self.isActive) {
					link.classList.add("active");
				}
			},
		});

      link.addEventListener("click", (event) => {

        event.preventDefault();

        links.forEach((item) => item.classList.remove("active"));
        link.classList.add("active");

        requestAnimationFrame(() => {
          const targetTop = target.getBoundingClientRect().top + window.scrollY;

          window.scrollTo({
            top: targetTop - offsetY,
            behavior: "smooth",
          });
        });


      });
    });
  });
}

pageNavigation();